module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=VC - Saint Vincent and the Grenadines.d431f7d2.svg";